<template>
  <div>
    <FormKit type="form" @submit="submitHandler" v-model="extra" :classes="{ outer: 'col-span-2' }">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-x-4">
        <!-- Instagram -->
        <div class="flex items-center space-x-2">
          <FormKit type="text" name="instagram" placeholder="@usuario" label="Instagram"
            :classes="{ outer: 'col-span-2 text-gray-800 font-medium' }" prefixIcon="instagram" />
        </div>
        <!-- Twitter -->
        <div class="flex items-center space-x-2">
          <FormKit type="text" name="twitter" placeholder="@usuario" label="Twitter"
            :classes="{ outer: 'col-span-2 text-gray-800 font-medium' }" prefixIcon="twitter" />
        </div>
        <!-- WhatsApp -->
        <div class="flex items-center space-x-2">
          <FormKit type="checkbox" label="Compartir mi Whatsapp" name="compartirTelefono"
            help="Se mostrará un icono de WhatsApp en tu perfil" :value="true" :classes="{
              outer: 'col-span-2 text-gray-800 font-medium',
              input: 'h-5 w-5 text-blue-600',
            }" />
        </div>
        <!-- Compartir mis datos -->
        <div class="flex items-center space-x-2">
          <FormKit type="checkbox" label="Ocultar mis datos" name="ocultarDatos"
            help="Ocultaremos tu perfil de la comunidad" :value="true" :classes="{
              outer: 'col-span-2 text-gray-800 font-medium',
              input: 'h-5 w-5 text-blue-600',
            }" />
        </div>
      </div>
      <template #submit>
        <div class="flex justify-end">
          <FormKit type="submit" :classes="{ outer: 'flex justify-end w-full' }" label="Guardar" />
        </div>
      </template>
    </FormKit>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { actualizar, miUsuario } from '@/services/usuarios';
// Modelo de usuario extra
const extra = ref({
  instagram: '',
  twitter: '',
  compartirTelefono: false,
  ocultarDatos: false,
});

onMounted(async () => {
  // Cargar los datos del usuario
  const usuario = await miUsuario();
  extra.value = usuario.extra;
});

// Manejador del envío del formulario
const submitHandler = async (data) => {
  console.log('Datos enviados:', data);
  const nuevoExtra = {
    extra: {
      ...extra.value,
      ...data
    }
  }

  await actualizar(nuevoExtra)
};
</script>